import { render, staticRenderFns } from "./AwardAnswerWrapper.vue?vue&type=template&id=d9682828&scoped=true"
import script from "./AwardAnswerWrapper.vue?vue&type=script&lang=js"
export * from "./AwardAnswerWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9682828",
  null
  
)

export default component.exports